export const GOOGLE_FONTS = [
    { name: 'Roboto', value: 'Roboto' },
    { name: 'Open Sans', value: 'Open Sans' },
    { name: 'Lato', value: 'Lato' },
    { name: 'Montserrat', value: 'Montserrat' },
    { name: 'Poppins', value: 'Poppins' },
    { name: 'Roboto Condensed', value: 'Roboto Condensed' },
    { name: 'Source Sans Pro', value: 'Source Sans Pro' },
    { name: 'Noto Sans', value: 'Noto Sans' },
    { name: 'Oswald', value: 'Oswald' },
    { name: 'Raleway', value: 'Raleway' }
  ];
  
  export const loadGoogleFont = (fontName) => {
    const link = document.createElement('link');
    link.href = `https://fonts.googleapis.com/css2?family=${fontName.replace(/ /g, '+')}&display=swap`;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  };